import { render, staticRenderFns } from "./PersonalKeys.vue?vue&type=template&id=675caa0c&"
import script from "./PersonalKeys.vue?vue&type=script&lang=ts&"
export * from "./PersonalKeys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports